<template>
  <v-container>
    <h3>Assignments</h3>
    <v-data-table
      :loading="isLoading"
      :headers="headers"
      :items="tables"
      :items-per-page="5"
      show-expand
      item-key="assignment_Start_Date"
      class="elevation-1"
    >
      <template v-slot:item.assignment_Start_Date="{ item }">
        {{ formatDate(item.assignment_Start_Date) }}
      </template>
      <template v-slot:expanded-item="{ headers, item }">
        <td :colspan="headers.length">
          <rates :tables="item.rates" />
        </td>
      </template>
    </v-data-table>
  </v-container>
</template>

<script>
import moment from "moment";
export default {
  props: ["tables"],
  components: {
    rates: () => import("./rates.vue")
  },
  data: () => ({
    headers: [
      {
        text: "Assignment Start Date",
        value: "assignment_Start_Date"
      },
      {
        text: "Department Code",
        value: "department_Code"
      },
      {
        text: "Location Code",
        value: "location_Code"
      },
      {
        text: "Job Code",
        value: "job_Code"
      },
      {
        text: "Rate Type",
        value: "rate_Type"
      }
    ],
    isLoading: false
  }),
  created() {},
  methods: {
    formatDate: date => moment(date).format("YYYY-MM-DD hh:mm A")
  }
};
</script>
